import React, { useState, useEffect, use } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layout/MainLayout';
import {
  Save,
  ArrowLeft,
  Info,
  List,
  Image as ImageIcon,
  Layout,
  Layers,
  Plus,
  Trash2,
  X,
  Upload,
  Check,
  Package,
  Activity,
  ChevronRight,
  FileText,
  DollarSign,
  Tag,
  Maximize2
} from 'lucide-react';
import './ProductEditor.css';
import { handleGetApi, handlePostApi } from '../../api/api';
import Cookies from 'js-cookie';

const AddProduct = () => {
  const navigate = useNavigate();
  const token = JSON.parse(Cookies.get('auth_token'));
  const headers = {
    Authorization: token
  }
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    category_id: '',
    subcategory_id: '',
    short_description: '',
    description: '',
    badge: '',
    rating: '',
    reviews: 0,
    mrp: '',
    price: '',
    stock: '',
    weight: '',
    height: '',
    proLength: '',
    breadth: '',
    status: 'Active',
    featured: false,
    is_new_arrival: false,
    thumbnail: '',
  });
  const category_id = formData?.category_id || null
    const fetchCategory = async () => {
    const res = await handleGetApi('admin/get/category', headers)
    setCategories(res.data)
  }
  const fetchSubCategory = async () => {
    const res = await handleGetApi(`admin/get/subCategoryById/${category_id}`, headers);
    setSubCategories(res.data || [])
  }
  useEffect(() => {
    fetchCategory();
  }, [])
  useEffect(()=>{
    if(category_id){
    fetchSubCategory();
    }
  }, [category_id])
  console.log(formData, 'formData')
  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    console.log('Saving Product:', formData);
    const sendData = new FormData();
    Object.entries(formData).forEach(([key, value])=>{
        sendData.append(key, value);
    })
    const res = await handlePostApi('admin/add/product', sendData, headers)
    console.log(res,'res')
    navigate('/products');
  };

  return (
    <MainLayout title='Add New Product'>
      <div className="product-editor-container fade-in">
        <div className="editor-header">
          <button className="back-btn" onClick={() => navigate('/products')}>
            <ArrowLeft size={20} />
            <span>Back to Products</span>
          </button>
          <div className="header-actions">
            <button className="save-product-btn" onClick={handleSave}>
              <Save size={20} />
              <span>Publish Product</span>
            </button>
          </div>
        </div>

        <div className="editor-layout" style={{display:"block"}}>

          <main className="editor-content-area">
            <div className="tab-panel">
                <div className="panel-content">
                  <div className="section-title"><FileText size={20} /> General Information</div>
                  <div className="basic-info-grid">
                    <div className="form-group full-width">
                      <label>Product Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="e.g. Modern Velvet Sofa"
                      />
                    </div>
                    <div className="form-group">
                      <label>Slug (URL Key)</label>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={handleInputChange}
                        placeholder="e.g. modern-velvet-sofa"
                      />
                    </div>
                    <div className="form-group">
                      <label>Badge (e.g. New, Bestseller)</label>
                      <input
                        type="text"
                        name="badge"
                        value={formData.badge}
                        onChange={handleInputChange}
                        placeholder="Optional"
                      />
                    </div>
                    <div className="form-group">
                      <label>Category</label>
                      <select name="category_id" value={formData.category_id} onChange={handleInputChange}>
                        <option value="">Select Category</option>
                        {categories?.map((cat) => {
                          return (
                            <option value={cat?.id}>{cat?.name}</option>
                          )
                        })}

                      </select>
                    </div>
                    <div className="form-group">
                      <label>Sub Category</label>
                      <select name="subcategory_id" value={formData.subcategory_id} onChange={handleInputChange}>
                        <option value="">Select Sub Category</option>
                        {subCategories && subCategories?.map((cat) => {
                          return (
                            <option value={cat?.id}>{cat?.name}</option>
                          )
                        })}
                      </select>
                    </div>
                    <div className="upload-card">

                      <div className="form-group">

                        <label>Main Thumbnail</label>

                        <div className="preview-box">

                          {
                            formData.thumbnail ? (

                              <img
                                src={
                                  typeof formData.thumbnail === "string"
                                    ? formData.thumbnail
                                    : URL.createObjectURL(formData.thumbnail)
                                }
                                alt="Thumb"
                              />

                            ) : (

                              <Upload size={40} />

                            )
                          }

                        </div>

                        <input
                          type="file"
                          id="thumbnail-upload"
                          hidden
                          accept="image/*"
                          onChange={(e) => {

                            const file = e.target.files[0];

                            if (file) {

                              setFormData((prev) => ({
                                ...prev,
                                thumbnail: file,
                              }));

                            }

                          }}
                        />
                        <label
                          htmlFor="thumbnail-upload"
                          className="upload-trigger-btn"
                        >
                          Select Image (jpg, jpeg, png, webp)
                        </label>

                      </div>

                    </div>
                  </div>

                  <div className="section-title"><DollarSign size={20} /> Pricing & Inventory</div>
                  <div className="basic-info-grid">
                    <div className="form-group">
                      <label>MRP (Original Price)</label>
                      <input
                        type="number"
                        name="mrp"
                        value={formData.mrp}
                        onChange={handleInputChange}
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-group">
                      <label>Current Price</label>
                      <input
                        type="number"
                        name="price"
                        value={formData.price}
                        onChange={handleInputChange}
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-group">
                      <label>Weight</label>
                      <input
                        type="number"
                        name="weight"
                        value={formData.weight}
                        onChange={handleInputChange}
                        placeholder="Weight in kg"
                      />
                    </div>
                    <div className="form-group">
                      <label>Height</label>
                      <input
                        type="number"
                        name="height"
                        value={formData.height}
                        onChange={handleInputChange}
                        placeholder="Height in cm"
                      />
                    </div>
                    <div className="form-group">
                      <label>Length</label>
                      <input
                        type="number"
                        name="proLength"
                        value={formData.proLength}
                        onChange={handleInputChange}
                        placeholder="Length in cm"
                      />
                    </div>
                    <div className="form-group">
                      <label>Breadth</label>
                      <input
                        type="number"
                        name="breadth"
                        value={formData.breadth}
                        onChange={handleInputChange}
                        placeholder="Breadth in cm"
                      />
                    </div>
                    <div className="form-group">
                      <label>Stock Quantity</label>
                      <input
                        type="number"
                        name="stock"
                        value={formData.stock}
                        onChange={handleInputChange}
                        placeholder="0"
                      />
                    </div>
                    <div className="form-group">
                      <label>Status</label>
                      <select name="status" value={formData.status} onChange={handleInputChange}>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Draft">Draft</option>
                      </select>
                    </div>
                  </div>

                  <div className="section-title"><Tag size={20} /> Descriptions</div>
                  <div className="panel-content" style={{ gap: '20px' }}>
                    <div className="form-group">
                      <label>Short Description</label>
                      <input
                        type="text"
                        name="short_description"
                        value={formData.short_description}
                        onChange={handleInputChange}
                        placeholder="A brief summary..."
                      />
                    </div>
                    <div className="form-group">
                      <label>Long Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows={6}
                        placeholder="Detailed product details..."
                      />
                    </div>
                  </div>

                  <div className="section-title"><Activity size={20} /> Extras</div>
                  <div className="basic-info-grid">
                    <div className="form-group">
                      <label>Average Rating</label>
                      <input
                        type="number"
                        step="0.1"
                        name="rating"
                        value={formData.rating}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label>Review Count</label>
                      <input
                        type="number"
                        name="reviews"
                        value={formData.reviews}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="featured"
                          checked={formData.featured}
                          onChange={handleInputChange}
                        />
                        <span>Feature this product on homepage</span>
                      </label>
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="is_new_arrival"
                          checked={formData.is_new_arrival}
                          onChange={handleInputChange}
                        />
                        <span>New Arrival this product on homepage</span>
                      </label>
                    </div>
                  </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddProduct;
